<template>
  <div class="home">
    <rates-intro/>
    <!-- <cost-cutting/> -->
    <terms/>
  </div>
</template>

<script>
// @ is an alias to /src
import RatesIntro from '@/components/RatesIntro.vue'
import CostCutting from '@/components/CostCutting.vue'
import Terms from '@/components/Terms.vue'


export default {
  name: 'home', 
  components: {
    RatesIntro,
    CostCutting,
    Terms
  }
}
</script>
